/**
 * Created by Denis Kuzin on 27 july 2022
 */

cc.CollectAnimation = function (duration, flyTo, options) {
    this.flyTo = flyTo;
    this.endPosition = this.getEndPosition(flyTo);
    this.options = options || {};

    cc.BezierBy.prototype.constructor.call(this, duration, []);
};

cc.CollectAnimation.prototype = Object.assign(Object.create(cc.BezierBy.prototype), {
    constructor: cc.CollectAnimation,

    startWithTarget: function (target) {
        cc.BezierBy.prototype.startWithTarget.call(this, target);

        if (this.flyTo.isRunning()) {
            this.endPosition = this.getEndPosition(this.flyTo);
        }

        const points = cc.CollectAnimation.calc3Points(target, this.endPosition, this.options);
        points[2] = cc.pSub(points[2], points[0]);
        points[1] = cc.pSub(points[1], points[0]);
        points[0] = cc.p(0, 0);

        this._config = points;
    },

    getEndPosition: function (flyTo) {
        return flyTo.convertToWorldSpace(cc.p(flyTo.width / 2, flyTo.height / 2));
    },

    update: function (dt) {
        if (this.flyTo.isRunning()) {
            const endPosition = this.getEndPosition(this.flyTo);

            const locConfig = this._config;
            locConfig[2] = cc.pAdd(locConfig[2], cc.pSub(this.target.parent.convertToNodeSpace(endPosition), this.target.parent.convertToNodeSpace(this.endPosition)));

            this.endPosition = endPosition;
        }

        cc.BezierBy.prototype.update.call(this, dt);
    }
});

cc.CollectAnimation.calc3Points = function (targetNode, endPosition, options) {
    options = options || {};
    const first = targetNode.getPosition();
    const third = targetNode.parent.convertToNodeSpace(endPosition);
    let second;

    if (options.jump) {
        second = cc.p(first.x, third.y);
    } else if (options.straight) {
        second = cc.pMidpoint(first, third);
    } else {
        const diff = cc.pSub(third, first);
        let height = Math.min(cleverapps.styles.CollectAnimation.height, cc.pLength(diff) * 1.5);
        if (options.randomPath) {
            height *= (Math.random() + 0.5);
        }
        const m = cc.pMidpoint(first, third);
        const perp = cc.pNormalize(cc.pPerp(diff));
        const opposite1 = cc.pMult(perp, Math.min(height, this.calcScaleFactor(m, perp, targetNode, 0)));
        const opposite2 = cc.pMult(perp, Math.min(height, this.calcScaleFactor(m, perp, targetNode, 1)));

        const second1 = cc.pAdd(m, perp);
        const second2 = cc.pSub(m, perp);

        const scene = cleverapps.Scenes.GetRunningScene();
        const center = targetNode.parent.convertToNodeSpace(cc.p(scene.width / 2, scene.height / 2));

        const dist1 = cc.pDistance(second1, center);
        const dist2 = cc.pDistance(second2, center);

        const back = options.randomPath ? m : cc.pSub(first, cc.pMult(diff, 0.33));

        second = dist1 < dist2 ? cc.pAdd(back, opposite1) : cc.pSub(back, opposite2);
    }

    return [first, second, third];
};

cc.CollectAnimation.calcScaleFactor = function (mid, second, targetNode, sideId) {
    const widthOpposite = Math.abs(second.x);

    const scene = cleverapps.Scenes.GetRunningScene();

    let sides = [
        { x: 0, y: 0 },
        { x: scene.width, y: scene.height }
    ];

    sides = sides.map((side) => targetNode.parent.convertToNodeSpace(side));

    const width = Math.abs(sides[sideId].x - mid.x);
    return width / widthOpposite;
};

cc.CollectAnimation.calcDuration = function (params) {
    let points = params.points;
    if (!points) {
        const endPosition = cc.CollectAnimation.prototype.getEndPosition(params.to);
        points = cc.CollectAnimation.calc3Points(params.targetNode, endPosition, params);
    }

    const distance = cc.pDistance(points[0], points[1]) + cc.pDistance(points[1], points[2]);
    const speed = params.speed || cleverapps.styles.CollectAnimation.speed;
    return Math.min(1, Math.max(0.3, distance / speed));
};

cleverapps.styles.CollectAnimation = {
    height: 700,
    speed: 2600
};